export const common = {
  // Navigation
  nav: {
    home: 'ホーム',
    products: '取扱商品',
    repair: '修理・お直し',
    about: '会社概要',
    news: 'お知らせ',
    contact: 'お問い合わせ',
  },

  // Product names
  products: {
    silentUmbrella: 'サイレントアンブレラ',
    braidUmbrella: '雅桜組ひも長傘',
    foldingUmbrella: 'レインポケット折傘',
    parasol: '晴雨兼用日傘',
    koshuWeaving: '甲州織',
    others: 'その他',
  },

  // Language names
  language: {
    japanese: '日本語',
    english: 'English',
    chinese: '中文',
  },

  // Home page sections
  home: {
    // Hero section
    hero: {
      slide1Products: {
        product1Alt: 'サイレントアンブレラ',
        product2Alt: '雅桜組ひも長傘',
        product3Alt: 'レインポケット折傘',
      },
      slide2: {
        title: '日本の職人の手作り',
        alt: 'メインビジュアル02',
      },
      slide3: {
        title: '伝統の技術で一本一本丁寧に作られた傘',
        alt: 'メインビジュアル03',
      },
    },

    // About section
    about: {
      heading: '丸安洋傘について',
      paragraph1: '1950年創業、丸安洋傘株式会社は70年以上にわたり高品質の傘を製作してまいりました。伝統的な日本の傘作りの技術を保存しながら、美しく機能的な傘を作るために現代の革新を取り入れることに専念しております。',
      paragraph2: '品質と職人技へのこだわりが、傘業界で信頼される名前となりました。サイレントアンブレラから伝統的な組ひもデザインまで、各製品は卓越性へのこだわりと細部への注意を反映しています。',
      button: '詳しく見る',
      imageAlt: '丸安洋傘の職人技',
      stat1Value: '70年以上',
      stat1Label: '経験年数',
      stat2Value: '100%',
      stat2Label: '品質保証',
      stat3Value: '50種以上',
      stat3Label: '製品バリエーション',
    },

    // Products section
    productsSection: {
      heading: '取扱商品',
      subtitle: 'PRODUCT',
      learnMore: '詳しく見る',
    },

    // Silent Umbrella section
    silentUmbrella: {
      heading: '雨音でストレスを感じていませんか?',
      subheading: '視覚障がいの方からの声「静かな傘がほしい」から生まれた雨音の静かな傘、サイレントアンブレラ',
      title: 'サイレントアンブレラ',
      subtitle: '静かで心地いい音に変わります。音に敏感な方！音楽など音響にたずさわる方におすすめです。',
      description: 'この傘は二重構造で雨滴の音を軽減し静かな雨音が落ち着いた気持ちを演出します。メッシュ生地と雨傘生地との立体空間が今までにないシルエットです。',
      recommendedUsesTitle: 'おすすめの使い方',
      use1: '周りの音がよく聞こえます',
      use2: '日陰にいるような涼しさです',
      use3: '雨の日のお仕事に',
      achievement1: '大学の学会にも取り上げて頂き発表していただきました。',
      achievement2: '雨音低減効果を有する雨傘の特許取得いたしました。',
      achievement3: 'サーモグラフィーカメラで一般の日傘との比較を実験いたしました。',
      imageAlt1: 'サイレントアンブレラ',
      imageAlt2: 'サイレントアンブレラ詳細',
      imageAlt3: 'サイレントアンブレラ動作',
    },

    // Braid Umbrella section
    braidUmbrella: {
      heading: '雅桜組ひも長傘',
      subheading: '組ひもと甲州織の融合',
      description1: '和の美意識が感じられる日本の傘を！',
      description2: '和の風合い漂う傘が出来上がりました。',
      paragraph1: '奈良吉野の山桜の持ち手に丁寧に組ひもを巻き施しています。気持ち良い手触りで軽く握るだけで滑りません。',
      achievement1: 'おもてなしセレクション受賞いたしました。',
      achievement2: '組ひも持ち手の実用新案取得いたしました。',
      imageAlt1: '雅桜組ひも長傘',
      imageAlt2: '雅桜組ひも長傘詳細',
    },

    // Folding Umbrella section
    foldingUmbrella: {
      heading: 'レインポケット折傘',
      subheading: '閉じたら、そのまま、すぐに収納',
      description1: '折りたたみ傘の悩みを解決！',
      description2: '閉じたらたたまず、サッと収納。',
      description3: '満員の電車、バスで折りたたみ傘の収納に困っていませんか？',
      paragraph1: '電車で荷物がある時、濡れた傘も楽に持ち運べてとても重宝します。',
      achievement1: 'TVの取材で放送されました。',
      achievement2: '特許を取得いたしました。',
      imageAlt1: 'レインポケット折傘',
      imageAlt2: 'レインポケット折傘詳細',
    },

    // Technology section
    technology: {
      heading: '私たちの技術',
      button: '詳しく見る',
      imageAlt: '技術',
    },

    // Applications section
    applications: {
      heading: '用途',
      subtitle: 'あらゆる場面に最適な傘を',
      dailyUse: '日常使い',
      dailyUseDesc: '雨や日差しから毎日を守る',
      business: 'ビジネス',
      businessDesc: 'ビジネスシーンに相応しい傘',
      specialEvents: '特別な場面',
      specialEventsDesc: '式典や特別な機会にふさわしいエレガントなデザイン',
      button: '製品を見る',
    },

    // Repair section
    repair: {
      heading: 'SDGs',
      subheading: '愛着ある傘が末永く使えます',
      paragraph1: '弊社で国内生産した傘は修理が可能です。規格により生地の張りが違うため、基本 弊社の国産傘のみの修理をお受けしております。',
      paragraph2: 'お客様の声より「修理・お直し」に関するお喜びの声をいただきました。',
      button: 'お礼のお言葉・修理依頼履歴',
      beforeRepairAlt: '修理前',
      afterRepairAlt: '修理後',
      beforeRepairLabel: '修理前',
      afterRepairLabel: '修理後',
    },

    // News section
    news: {
      heading: 'お知らせ',
      subtitle: 'NEWS',
      button: '一覧を見る',
    },

    // Media section
    media: {
      imageAlt: 'レインポケット雫テレビで紹介されました',
      videoTitle: 'レインポケット雫 - YouTube動画プレーヤー',
    },

    // Social section
    social: {
      facebookTitle: '\\FaceBook 随時更新中/',
      facebookFeedText: 'Facebookフィード',
      facebookFollowText: '最新情報をフォロー',
      purchaseTitle: '\\購入はこちらから/',
      baseAlt: 'BASE',
      youtubeAlt: 'YOUTUBE',
      yahooShoppingAlt: 'yahooショッピング',
      instagramAlt: 'instagram',
    },

    // Company section
    company: {
      heading: '大阪阿倍野 日本の職人手作り',
      subheading: '丸安洋傘株式会社',
      description: '大阪阿倍野のJR寺田町駅の近くに工房があります。先代から引き継いだ技法と半世紀以上使い続けている道具で手作りしています。',
      button: '会社概要',
      imageAlt: '会社概要',
    },

    // Contact section
    contact: {
      heading: 'お問い合わせ',
      subtitle: 'CONTACT',
      phone: '06-6713-8308',
      businessHours: '営業時間 10:00~17:00(定休日:土・日・祝)',
      emailButton: 'メールでのお問い合わせ',
      onlineStoreAlt: '販売サイトはこちら',
    },
  },

  // Footer
  footer: {
    companyName: '丸安洋傘株式会社',
    logoAlt: '丸安洋傘株式会社|職人が手作りした日本製の傘',
    address: {
      postalCode: '〒545-0001',
      line1: '大阪市阿倍野区天王寺町北2-6-15',
      line2: '',
    },
    navigation: {
      home: 'ホーム',
      productsHeading: '取扱商品',
      silentUmbrella: '- サイレントアンブレラ',
      braidUmbrella: '- 雅桜組ひも長傘',
      foldingUmbrella: '- レインポケット折傘',
      parasol: '- 晴雨兼用日傘',
      koshuOri: '- 甲州織',
      others: '- その他',
      aboutUs: '会社概要',
      news: 'お知らせ',
      repairService: '修理・お直し',
      contact: 'お問い合わせ',
      sitemap: 'サイトマップ',
    },
    copyright: 'Copyright © 丸安洋傘株式会社 All rights reserved.',
    websiteBuilder: 'ウェブサイトビルダー',
  },

  // Common elements
  common: {
    learnMore: '詳しく見る',
    viewProducts: '製品を見る',
    watchVideo: '動画を見る',
    emailInquiry: 'メールでのお問い合わせ',
    businessHours: '営業時間 10:00~17:00(定休日:土・日・祝)',
    phone: '06-6713-8308',
    onlineStore: '販売サイトはこちら',
  },

  // About page
  aboutPage: {
    heroTitle: '会社概要',
    heroSubtitle: 'COMPANY',
    companyHeading: '会社概要',
    companySubtitle: 'COMPANY',
    mapHeading: 'アクセスマップ',
    mapSubtitle: 'MAP',
    tableName: '会社名',
    tableNameValue: '丸安洋傘株式会社',
    tableAddress: '所在地',
    tableAddressValue: '〒545-0001 大阪市阿倍野区天王寺町北2-6-15',
    tableHours: '営業時間',
    tableHoursValue: '10：00～17：00',
    tableClosed: '休業日',
    tableClosedValue: '土・日・祝祭日・夏季・年末年始',
    tableTel: 'TEL',
    img1Alt: '丸安洋傘株式会社 外観',
    img2Alt: '丸安洋傘株式会社 工房',
  },

  // Contact page
  contactPage: {
    heroTitle: 'お問い合わせ',
    heroSubtitle: 'CONTACT',
    intro1: 'ご質問・ご相談・その他のお問い合わせは下記フォームにてお問い合わせください。',
    intro2: 'また、お電話にてもお問い合わせをお受けしております。',
    intro3: '各項目を入力の上、「送信する」ボタンをクリックしてください。',
    formName: 'お名前',
    formNameSei: '姓',
    formNameMei: '名',
    formFurigana: 'フリガナ',
    formFuriganaSei: 'セイ',
    formFuriganaMei: 'メイ',
    formEmail: 'メールアドレス',
    formPhone: '電話番号',
    formMessage: 'お問い合わせ内容',
    formMessagePlaceholder: '500文字以内でお願いします。',
    formMessageCount: '文字',
    formPrivacy: '個人情報の取り扱いについて',
    formPrivacyAgree: '個人情報の取り扱いについて同意する',
    required: '必須',
    submit: '送信する',
    submitting: '送信中...',
    submitSuccess: 'お問い合わせを受け付けました。近日中にご連絡いたします。',
    submitError: '送信に失敗しました。もう一度お試しください。',
    submitErrorNetwork: 'エラーが発生しました。もう一度お試しください。',
    infoTitle: 'お問い合わせ',
    infoPhone: '06-6713-8308',
    infoHours: '営業時間 10:00~17:00（定休日：土・日・祝）',
    infoEmail: 'メールでのお問い合わせ',
    infoEmailSub: '左のフォームをご利用ください',
    privacyText1: '丸安洋傘株式会社（以下、「当社」という。）は、以下のとおり個人情報保護方針を定め、個人情報保護の仕組みを構築し、全従業員に個人情報保護の重要性の認識と取組みを徹底させることにより、個人情報の保護を推進致します。',
    privacyH1: '【個人情報の管理】',
    privacyP1: '当社は、お客さまの個人情報を正確かつ最新の状態に保ち、個人情報への不正アクセス・紛失・破損・改ざん・漏洩などを防止するため、セキュリティシステムの維持・管理体制の整備・社員教育の徹底等の必要な措置を講じ、安全対策を実施し個人情報の厳重な管理を行ないます。',
    privacyH2: '【個人情報の利用目的】',
    privacyP2: 'お客さまからいただいた個人情報は、当社からのメール・資料の送付、当社のサービス・事業のご案内のために利用いたします。',
    privacyH3: '【個人情報の第三者への開示・提供の禁止】',
    privacyP3: '当社は、お客さまよりお預かりした個人情報を適切に管理し、次のいずれかに該当する場合を除き、個人情報を第三者に開示いたしません。',
    privacyList1: 'お客さまの同意がある場合',
    privacyList2: 'お客さまが希望されるサービスを行なうために当社が業務を委託する業者に対して開示する場合',
    privacyList3: '法令に基づき開示することが必要である場合',
    privacyH4: '【個人情報の安全対策】',
    privacyP4: '当社は、個人情報の正確性及び安全性確保のために、セキュリティに万全の対策を講じています。',
    privacyH5: '【ご本人の照会】',
    privacyP5: 'お客さまがご本人の個人情報の照会・修正・削除などをご希望される場合には、ご本人であることを確認の上、対応させていただきます。',
    privacyH6: '【法令、規範の遵守と見直し】',
    privacyP6: '当社は、保有する個人情報に関して適用される日本の法令、その他規範を遵守するとともに、本ポリシーの内容を適宜見直し、その改善に努めます。',
    privacyH7: '【お問い合わせ】',
    privacyP7: '当社の個人情報の取扱いに関するお問い合わせは下記までご連絡ください。',
    privacyCompany: '丸安洋傘株式会社',
    privacyPostal: '〒545-0001',
    privacyAddress: '大阪市阿倍野区天王寺町北2-6-15',
    privacyTel: 'TEL：06-6713-8308',
  },

  // Braid Umbrella product page
  braidPage: {
    heroTitle: '雅桜組ひも長傘',
    heroSubtitle: 'PRODUCT',
    breadcrumbHome: 'ホーム',
    breadcrumbCurrent: '雅桜組ひも長傘',
    catchphrase: '和の美意識が感じられる日本の傘と言える傘を！',
    sec1Heading: '日本の伝統工芸の組ひも',
    sec1Body: '雅桜はそのコンセプトから作られました。山桜、甲州織、日本を感じられる素材を使い職人が1本1本手作りしています。甲州織の生地は、糸を染色してから織るため、タテ糸とヨコ糸が織りなす上品で重厚な手触りと風合い、独特の光沢があります。',
    sec2Heading: '組ひもと傘の融合',
    sec2Body: '着物の帯締めから着想を得て組ひもを奈良吉野の希少な山桜を削り出して仕上げた持ち手に丁寧に巻き施しています。雅桜の握り感は、今までにない感触で心地いい手触りです。傘を差した時に持ち手が滑りません。甲州織と組ひも、独特の風合いが、メイドインジャパンの傘と言える一品に仕上がりました。',
    centerText: '10本の紐を平織で手編みした組ひもを山桜の持ち手に丁寧に巻き施しています。',
    sec3Heading: '末広がりの縁起物',
    sec3Body: '傘は昔から末広がりの縁起物として扱われ、結納の贈り物や引き出物としても使われてきました。大切な方への贈り物としても最適です。不具合が発生しても依頼を頂ければすぐに修理ができるので末永くお使いいただけます。',
    videoHeading: '動画紹介',
    videoSubtitle: 'MOVIE',
    awardOmotenashi: '※おもてなしセレクション受賞。',
    awardUtility: '※組ひも持ち手の実用新案取得。',
    contactHeading: 'お問い合わせ',
    contactSubtitle: 'CONTACT',
    contactPhone: '06-6713-8308',
    contactHours: '営業時間 10:00~17:00（定休日：土・日・祝）',
    contactEmail: 'メールでお問い合わせ',
    onlineStoreAlt: 'オンラインショップはこちら',
    img1Alt: '雅桜組ひも長傘',
    img2Alt: '組ひもと傘の融合',
    img3Alt: '末広がりの縁起物',
  },
};
